import axios from 'axios';

class ApiClient {
  constructor(proxyUrl) {
    this.proxyUrl = proxyUrl;
    this.apiUrl = '';
    this.projectCode = '';
    this.scopedToken = '';
    this.token = '';
  }

  setProxyUrl(proxyUrl) {
    this.proxyUrl = proxyUrl;
  }

  setApiUrl(apiUrl) {
    this.apiUrl = apiUrl;
  }

  setProjectCode(projectCode) {
    this.projectCode = projectCode;
  }

  setScopedToken(scopedToken) {
    this.scopedToken = scopedToken;
  }

  getProxyUrl(path) {
    const url = new URL(`https://${this.proxyUrl}${path}`);
    
    url.searchParams.append('url', this.apiUrl);
    url.searchParams.append('scopedToken', this.scopedToken);
    
    return url.toString();
  }

  setToken(token) {
    this.token = token;
  }

  async request(method, path, data = null, callback = null, isFileResponse = false, headers = null) {

    const config = {
      method: method,
      url: this.getProxyUrl(path),
      headers: {
        'Content-Type': 'application/json',
        // Per-request headers win (e.g. Content-Encoding: gzip for compressed
        // bodies). NOTE: a Uint8Array/ArrayBuffer body passes through axios
        // untouched — do not JSON.stringify binary bodies before calling.
        ...(headers || {})
      }
    };
  
    if (isFileResponse) {
      config.responseType = 'arraybuffer';
      config.transformResponse = [];
      config.headers['Accept'] = '*/*';
    }
  
    if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
      config.data = data;
    }
  
    try {
      const response = await axios(config);
      
      if (callback) {
        if (isFileResponse) {
          await callback(response);
        } else {
          await callback(response.data);
        }
      }
      
      return response.data;
    } catch (error) {
      console.error(`Error in ${method} request:`, error);
      throw error;
    }
  }


  async get(path, callback, isFileResponse) {
    return this.request('GET', path, null, callback, isFileResponse);
  }

  async post(path, data, callback, isFileResponse, headers) {
    return this.request('POST', path, data, callback, isFileResponse, headers);
  }

  async put(path, data, callback, isFileResponse, headers) {
    return this.request('PUT', path, data, callback, isFileResponse, headers);
  }

  async patch(path, data, callback, isFileResponse, headers) {
    return this.request('PATCH', path, data, callback, isFileResponse, headers);
  }
}

export default ApiClient;